import User from "../../../apis/User";
import Dbsubs from "../../../apis/Dbsubs";
import router from "../../../router";

const state = {
    dbsubs: [],
    dbsubError: ""
};

const getters = {};

const actions = {
    getAllDbsubs({ commit }) {
        return new Promise((resolve, reject) => {
            Dbsubs.index()
                .then((response) => {
                    resolve(response.data.data);
                    commit("GET_ALL_DBSUBS", response.data.data)
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("GET_ALL_DBSUBS", []);
                        commit("DETECT_DBSUBS_ERROR", error.response);
                    }
                })
        });
    },
    getDbsub({ commit }, id) {
        return new Promise((resolve, reject) => {
            Dbsubs.show(id)
                .then((response) => {
                    resolve(response.data.data);
                    commit("GET_DBSUB", id);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_DBSUBS_ERROR", error.response);
                    }
                })
        })
    },
    createDbsub({ commit }, obj) {
        return new Promise((resolve, reject) => {
            Dbsubs.store(obj)
                .then((response) => {
                    resolve(response.data.data[0]);

                    return response.data.data[0];
                })
                .then((response) => {
                    commit("CREATE_DBSUB", response);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_DBSUBS_ERROR", error.response);
                    }
                })
        })
    },
    updateDbsub({ commit }, { id, obj }) {
        return new Promise((resolve, reject) => {
            Dbsubs.update(id, obj)
                .then((response) => {
                    resolve(response.data.data);
                    commit("UPDATE_DBSUB", obj);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_DBSUBS_ERROR", error.response);
                    }
                })
        })
    },
    removeDbsub({ commit }, id) {
        return new Promise((resolve, reject) => {
            Dbsubs.delete(id)
                .then((response) => {
                    resolve(response.data.data);
                    commit("REMOVE_DBSUB", id);
                })
                .catch((error) => {
                    reject(error);

                    if (error.response) {
                        commit("DETECT_DBSUBS_ERROR", error.response);
                    }
                })
        })
    }
};

const mutations = {
    GET_ALL_DBSUBS(state, response) {
        state.dbsubs = response;
    },
    GET_DBSUB(state, id) {

    },
    CREATE_DBSUB(state, obj) {
        state.dbsubs.push(obj);
    },
    UPDATE_DBSUB(state, obj) {
        let objIndexToUpdate = state.dbsubs.findIndex(el => el.id === obj.id);
        state.dbsubs[objIndexToUpdate] = obj;
    },
    REMOVE_DBSUB(state, id) {
        let objIndexToDelete = state.dbsubs.findIndex(el => el.id === id);
        state.dbsubs.splice(objIndexToDelete, 1);
    },
    DETECT_DBSUBS_ERROR(state, error) {
        setTimeout(() => {
            state.dbsubError = "";
        }, 1000)

        if (error.status == 401 || error.status == 419) {
            User.logout().then(() => {
                localStorage.removeItem("auth");
                router.push({ name: "Login", path: router.currentRoute.path });
            })
        } else if (error.data.message !== undefined) {
            state.dbsubError = error.data.message;
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}